import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import VisitorReportsLayer from "../components/VisitorReportsLayer";

const VisitorReportsPage = () => {
    return (
        <MasterLayout>
            <VisitorReportsLayer />
        </MasterLayout>
    );
};

export default VisitorReportsPage;
